export const MAX_DISTANCE_LIMIT_IN_KM = 30;
export const MAX_TRANSPARENT_DISTANCE_IN_KM = 20;
export const MAX_DISTANCE_LIMIT_IN_KM_EXTENDED = 50;
export const MAX_DISTANCE_LIMIT_IN_KM_MAX = 100;
export const KILO = 1000;
export const ITEMS_PER_PAGE = 20;
export const EXTENDED_JOB_POSITION_LIMIT = 3;
export const DISTANCE_RADIUS_FOR_RELATED_JOBS_IN_KM = 5;
export const MIN_JOB_RESULTS_THRESHOLD = 6;
export const RADIUS_EXPANSION_STEP_1_IN_KM = 40;
export const RADIUS_EXPANSION_STEP_2_IN_KM = 50;
export const RADIUS_EXPANSION_STEP_3_IN_KM = 60;
export const RADIUS_EXPANSION_STEP_4_IN_KM = 75;
export const RADIUS_EXPANSION_STEP_5_IN_KM = 100;
export const RADIUS_EXPANSION_STEPS = [
  RADIUS_EXPANSION_STEP_1_IN_KM,
  RADIUS_EXPANSION_STEP_2_IN_KM,
  RADIUS_EXPANSION_STEP_3_IN_KM,
  RADIUS_EXPANSION_STEP_4_IN_KM,
  RADIUS_EXPANSION_STEP_5_IN_KM,
] as const;
